import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: (p) => p.spacing(1),
};

export const header: SxStyle = {
  width: '100%',
};

export const labelWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: (p) => p.spacing(0.5),
  flexWrap: 'wrap',
};
